import React from 'react';
import FormSection from '../../FormElements/FormSection';
import TextInput from '../../FormElements/TextInput';
import EmailInput from '../../FormElements/EmailInput';
import FormSubmit from '../../FormElements/FormSubmit';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import GlobalInfoAlert from '../../Alerts/GlobalInfoAlert';
import OrganizationSelectbox from '../../FormElements/OrganizationSelectbox';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class CreateAccountForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			organization: null,
			globalErrors: [],
			fieldErrors: null,
			loading: false,
			hasError: true,
			organization: {
				organizationLegalName: '',
				organizationId: '',
				isNew: true
			},
			accountName: '',
			classroomPathSegment: '',
			administratorEmailAddress: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeOrganization = this.onChangeOrganization.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		// console.log(
		// 	'Create Account Form - Props',
		// 	this.props,
		// 	'Create Account Form - State',
		// 	this.state
		// );
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						{this.props.cloneAccount.name && (
							<GlobalInfoAlert
								globalInfoAlerts={I18n.t('admin.clone_account_info_alert', {
									clonedAccountName: this.props.cloneAccount.name
								})}
							/>
						)}
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<OrganizationSelectbox
							permissionsHelper={this.props.permissionsHelper}
							style={this.styleTextInputOnError('organizationToken')}
							placeholder={I18n.t('organization_token')}
							name="organizationToken"
							onChange={this.onChangeOrganization}
							fieldErrors={this.state.fieldErrors}
							helperText={I18n.t('admin.helper_text.org_name_search')}
						/>
						<TextInput
							style={this.styleTextInputOnError('accountName')}
							placeholder={I18n.t('account_name')}
							name="accountName"
							value={this.state.accountName}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
							helperText={I18n.t('admin.helper_text.new_account_name')}
						/>
						<TextInput
							style={this.styleTextInputOnError('classroomPathSegment')}
							placeholder={I18n.t('public_id')}
							name="classroomPathSegment"
							value={this.state.classroomPathSegment}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
							helperText={I18n.t('admin.helper_text.public_id')}
						/>
						<EmailInput
							style={this.styleTextInputOnError('administratorEmailAddress')}
							placeholder={I18n.t('administrator_email')}
							name="administratorEmailAddress"
							value={this.state.administratorEmailAddress}
							onChange={this.onChange}
							fieldErrors={this.state.fieldErrors}
							helperText={I18n.t('admin.helper_text.admin_email')}
						/>
					</FormSection>
					<FormSubmit text="Create Account" />
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onChangeOrganization(e) {
		const { text = '', id = '', isNew = false } = e;
		this.setState({
			organization: {
				organizationLegalName: text,
				organizationId: id,
				isNew: isNew
			}
		});
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true,
			globalErrors: null,
			fieldErrors: null
		});

		$.ajax({
			type: 'POST',
			url: this.props.iam_account_create_endpoint,
			data: {
				organization: this.state.organization,
				accountName: this.state.accountName,
				classroomPathSegment: this.state.classroomPathSegment,
				administratorEmailAddress: this.state.administratorEmailAddress,
				cloneAccountId: this.props.cloneAccount.id
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data);
			if (data.status == 'success') {
				// console.log('Account successfully created!', data);
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onNewAccountCreation(this.state.accountName);
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('Account creation failed!');
				this.setState({
					loading: false,
					globalErrors: data.global_errors,
					fieldErrors: data.field_errors
				});
			}
		});
	}
}
